import React from 'react'

export function NotFound() {
  return (
    <div>
      <p>Page not found.</p>
      <p>No Coins here.</p>
    </div>
  )
}
